{
  "general": {
    "cancel": "Tühista",
    "delete": "Kustuta",
    "no": "Ei",
    "ok": "Ok",
    "yes": "Jah",
    "selectGender": "Vali sugu",
    "gender": {
      "male": "Mees",
      "female": "Naine"
    }
  },
  "menu": {
    "departments": "Osakonnad",
    "home": "Avaleht",
    "procedures": "Protseduurid",
    "scheduling": "Kalender",
    "users": "Kasutajad"
  },
  "procedures": {
    "addProcedure": "Lisa protseduur",
    "deleteProcedure": "Kustuta protseduur",
    "searchProcedures": "Otsi protseduure"
  },
  "approvalRequest": {
    "actionType": "Toimingu tüüp",
    "requestedBy": "Taotleja",
    "approvedBy": "Kinnitaja",
    "confirms": {
      "approveTitle": "Kinnita taotlus",
      "approveText": "Kas oled kindel, et soovid selle taotluse kinnitada?",
      "rejectTitle": "Lükka taotlus tagasi",
      "rejectText": "Palun esita põhjus selle taotluse tagasilükkamiseks.",
      "rejectReasonPlaceholder": "Tagasilükkamise põhjus"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Õiguse andmine",
      "PERMISSION_REVOKE": "Õiguse tühistamine",
      "EXPORT_VISITS": "Visiitide eksport",
      "EXPORT_LOCATION_HISTORY": "Asukohajaloo eksport",
      "EXPORT_ARRIVAL_HISTORY": "Saabumisajaloo eksport",
      "ENABLE_USER": "Aktiveeri kasutaja",
      "DISABLE_USER": "Deaktiveeri kasutaja"
    },
    "toasts": {
      "created": "Kinnituse taotlus loodud",
      "applied": "Toiming rakendatud",
      "applyFailed": "Toimingu rakendamine ebaõnnestus",
      "approved": "Taotlus kinnitatud",
      "approveFailed": "Taotluse kinnitamine ebaõnnestus",
      "rejected": "Taotlus tagasi lükatud",
      "rejectFailed": "Taotluse tagasilükkamine ebaõnnestus"
    }
  },
  "step": {
    "transitionToNextStep": "Üleminek järgmisele sammule",
    "transitionType": "Ülemineku tüüp",
    "parentStep": "Eelnev samm",
    "previousStep": "Eelmine samm",
    "option": "Valik",
    "editStep": "Muuda sammu",
    "description": "Kirjeldus",
    "addNewStep": "Lisa uus samm",
    "owner": "Omanik",
    "viewInProcedure": "Vaata protseduuris",
    "stepMedia": "Sammu meedia",
    "saveMedia": "Salvesta",
    "dropFilesOrClickToUpload": "Lohista failid siia või kliki üleslaadimiseks",
    "addDescription": "Lisa kirjeldus",
    "chooseType": "Vali tüüp",
    "insertOption": "Sisesta valik",
    "insertMinValue": "Sisesta MIN väärtus",
    "insertMaxValue": "Sisesta MAX väärtus",
    "chooseTransitionType": "Vali ülemineku tüüp",
    "chooseParentSep": "Vali eelnev samm",
    "chooseStepOption": "Vali sammu valik",
    "addParentStep": "Lisa eelnev samm",
    "type": "Tüüp",
    "value": "Väärtus",
    "error": {
      "WONT_REACH_END": "Puudub tee LÕPUNI",
      "EXIT_NOT_IN_USE": "Kasutamata väljund",
      "NO_PARENT_SET": "Puudub eelnev samm",
      "PARENT_NOT_EXITS": "Määratud eelmine samm ei eksisteeri",
      "DUPLICATE_START": "Protseduuril saab olla ainult üks ALGUSE samm",
      "DUPLICATE_END": "Protseduuril saab olla ainult üks LÕPU samm"
    }
  }
}
